<template>
  <div class="dashboard-chart-bar">
    <h2>{{ charttitle }}</h2>
    <div class="dashboard-chart-line-container">
      <div class="dashboard-chart-line-component" :id="chartid"></div>
      <div class="nodatachartinfo" v-if="!chartdata">{{ $t("DashboardProduct.nodata") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineChart',
  props: {
    animation: Boolean,
    chartid: String,
    charttitle: String,
    chartdata: {
      type: Object
    }
  },
  created() {
    this.$nextTick(() => {
      this.initLineChart(this.chartdata)
    });
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initLineChart(this.chartdata)
      });
    }
  },
  methods: {

    /**
     * 趋势图
     */
    initLineChart: function(chartdata){
      if(document.getElementById(this.chartid) === null) return
      let myChart = this.$echarts.init(document.getElementById(this.chartid))
      myChart.clear()
      myChart.setOption({
        legend: {
          top: 0,
          icon: 'pin'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer:{
            type: 'line',
            lineStyle: {
              color: '#ccc'
            }
          },
        },
        grid:{
          top: 30,
          left: 20,
          right: 20,
          bottom: 5,
          containLabel: true
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          data: chartdata.xAxis_data
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999',
            fontSize: 12
          }
        },
        series : chartdata.series_data
      })
      $(window).resize(function () {
        myChart.resize()
      })
    },

  }
}
</script>
